<div class="stock-details">
  <div class="stock-details__header">
    <div>
      <span class="stock-details__eyebrow">Dettagli stock</span>

      <h2 *ngIf="productName">
        {{ productName }}
      </h2>

      <p *ngIf="!variantName">
        Controlla le righe di stock attuali e lo storico dei movimenti di stock.
      </p>

      <p *ngIf="variantName">
        Variante: <strong>{{ variantName }}</strong>
      </p>
    </div>

    <div class="stock-details__actions">
      <div class="stock-details__summary">
        <span>Disponibile</span>

        <strong *ngIf="!loadingAvailableStock">
          {{ availableStock }}
        </strong>

        <strong *ngIf="loadingAvailableStock">
          ...
        </strong>
      </div>

      <button
        type="button"
        class="stock-details__close"
        (click)="close()"
        aria-label="Chiudi"
      >
        ×
      </button>
    </div>
  </div>

  <div class="stock-filters">
    <div class="filter-field filter-field--search">
      <label>Cerca</label>
      <input
        type="text"
        [(ngModel)]="filters.search"
        (ngModelChange)="onFilterChange('search', $event)"
        placeholder="Cerca lotto, motivo, consegna..."
      />
    </div>

    <div class="filter-field">
      <label>Da</label>
      <input
        type="date"
        [(ngModel)]="filters.dateFrom"
        (ngModelChange)="onFilterChange('dateFrom', $event)"
      />
    </div>

    <div class="filter-field">
      <label>A</label>
      <input
        type="date"
        [(ngModel)]="filters.dateTo"
        (ngModelChange)="onFilterChange('dateTo', $event)"
      />
    </div>

    <div class="filter-field" *ngIf="activeTab === 'lines'">
      <label>Stato</label>
      <select 
        [(ngModel)]="filters.status" 
        (ngModelChange)="onFilterChange('status', $event)"
      >
        <option value="">Tutti</option>
        <option value="AVAILABLE">Disponibile</option>
        <option value="CONSUMED">Consumata</option>
        <option value="DAMAGED">Danneggiata</option>
        <option value="EXPIRED">Scaduta</option>
      </select>
    </div>

    <div class="filter-field" *ngIf="activeTab === 'movements'">
      <label>Tipo</label>
      <select 
        [(ngModel)]="filters.type" 
        (ngModelChange)="onFilterChange('type', $event)"
      >
        <option value="">Tutti</option>
        <option value="INBOUND">In entrata</option>
        <option value="OUTBOUND">In uscita</option>
      </select>
    </div>

    <div class="filter-actions">
      <button type="button" (click)="resetFilters()">
        Reimposta
      </button>
    </div>
  </div>

  <div class="stock-details__tabs">
    <button
      type="button"
      [class.active]="activeTab === 'lines'"
      (click)="setTab('lines')"
    >
      Righe stock
    </button>

    <button
      type="button"
      [class.active]="activeTab === 'movements'"
      (click)="setTab('movements')"
    >
      Movimenti
    </button>
  </div>

  <div class="stock-details__body">
    <app-stock-lines
      *ngIf="activeTab === 'lines'"
      [productId]="productId"
      [partnerId]="partnerId"
      [productVariantId]="productVariantId"
      [filters]="filters"
    ></app-stock-lines>

    <app-stock-movements
      *ngIf="activeTab === 'movements'"
      [productId]="productId"
      [partnerId]="partnerId"
      [productVariantId]="productVariantId"
      [filters]="filters"
    ></app-stock-movements>
  </div>
</div>